// import React, { useEffect, useState, useRef } from 'react';
// import client from '../../sanity/client';
// import '../Chemin/CheminPage.scss';
// import { ArrowLeft, ArrowRight } from '../../assets/svg';
// import { useLanguage } from '../../components/LanguageContext'; // Importer le contexte

// const TransmissionPage = () => {
//   const [data, setData] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const { language } = useLanguage(); // Récupérer la langue actuelle

//   useEffect(() => {
//     const fetchData = async () => {
//       const query = `*[_type == "transmission"][0]{
//         title,
//         carrousel[]{ "imageUrl": asset->url + "?auto=format" },
//         colonneGauche,
//         colonneDroite
//       }`;

//       const result = await client.fetch(query);
//       console.log(result); // Vérifiez le contenu de result ici
//       setData(result);
//     };

//     fetchData();
//   }, []);


//   const goToNextSlide = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % data.carrousel.length);
//   };

//   const goToPrevSlide = () => {
//     setCurrentIndex((prevIndex) => (prevIndex - 1 + data.carrousel.length) % data.carrousel.length);
//   };

//   if (!data) return <div>Loading...</div>;

//   return (
//     <>
//       <div className="chemin-page titre-page">
//         <h1 className="chemin-text">{data.title[language]}</h1>

//         {data.carrousel?.length > 0 && (
//           <div className="carousel">
//             {/* Affichage de toutes les images, seule celle active aura l'opacité 1 */}
//             <div className="carousel-image-container">
//               {data.carrousel.map((image, index) => (
//                 <img
//                   key={index}
//                   src={image.imageUrl}
//                   alt={`Slide ${index + 1}`}
//                   className={`carousel-image ${index === currentIndex ? 'active' : ''}`}
//                 />
//               ))}
//             </div>

//             {/* Flèches de navigation */}
//             <div className="carousel-controls">
//               <button className="carousel-control prev" onClick={goToPrevSlide}>
//                 <ArrowLeft />
//               </button>
//               <button className="carousel-control next" onClick={goToNextSlide}>
//                 <ArrowRight />
//               </button>
//             </div>
//           </div>
//         )}
//       </div>
//       <section className='text_section'>
//         <div className='text_parts'>
//           <div className='text_content_left'>
//             {data.colonneGauche?.[language]?.map((paragraph, idx) => (
//               <p key={idx}>
//                 {paragraph.split('\n').map((line, i) => (
//                   <span key={i}>
//                     {line}
//                     <br />
//                   </span>
//                 ))}
//               </p>
//             ))}
//           </div>
//           <div className='text_content_right'>
//             {data.colonneDroite?.[language]?.map((paragraph, idx) => (
//               <p key={idx}>
//                 {paragraph.split('\n').map((line, i) => (
//                   <span key={i}>
//                     {line}
//                     <br />
//                   </span>
//                 ))}
//               </p>
//             ))}
//           </div>
//         </div>
//       </section>
//   </>
//   );
// };

// export default TransmissionPage;

import React, { useEffect, useState, useRef } from 'react';
import client from '../../sanity/client';
import '../Chemin/CheminPage.scss';
import { ArrowLeft, ArrowRight } from '../../assets/svg';
import { useLanguage } from '../../components/LanguageContext';
import { useLocation } from 'react-router-dom';
import SubPage from '../Transmission/SubPage';

const TransmissionPage = () => {
  const location = useLocation();
  const [data, setData] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const intervalRef = useRef(null);
  const { language } = useLanguage();

  // Gestion du scroll vers les ancres après navigation
  useEffect(() => {
    if (location.state?.scrollTo) {
      const scrollToId = location.state.scrollTo;
      const tryScroll = () => {
        const el = document.getElementById(scrollToId);
        if (el) {
          // Attendre que AOS ait positionné les éléments
          setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 300); // Délai pour attendre les animations AOS
        } else {
          // Attente si le DOM n'est pas prêt
          setTimeout(tryScroll, 100);
        }
      };
      tryScroll();
    }
  }, [location.state, data]); // Dépendre aussi de data pour s'assurer que les sous-pages sont montées

  useEffect(() => {
    const fetchData = async () => {
      const query = `*[_type == "transmission"][0]{
        title,
        carrousel[]{ "imageUrl": asset->url + "?auto=format" },
        colonneGauche,
        colonneDroite
      }`;

      const result = await client.fetch(query);
      setData(result);
      startAutoSlide(result);
    };

    fetchData();

    return () => clearInterval(intervalRef.current);
  }, []);

  const startAutoSlide = (data) => {
    clearInterval(intervalRef.current);
    if (data?.carrousel?.length > 1) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % data.carrousel.length);
      }, 3000);
    }
  };

  const resetAutoSlide = () => {
    if (data) startAutoSlide(data);
  };

  const goToNextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % data.carrousel.length);
    resetAutoSlide();
  };

  const goToPrevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + data.carrousel.length) % data.carrousel.length);
    resetAutoSlide();
  };

  if (!data) return <div>Loading...</div>;

  return (
    <>
      <div id="transmission" className="chemin-page titre-page">
        <h1 className="chemin-text" data-aos="fade-in" data-aos-duration="800">
          {data.title[language]}
        </h1>

        {data.carrousel?.length > 0 && (
          <div className="carousel" data-aos="fade-in" data-aos-duration="1000" data-aos-delay="200">
            <div className="carousel-image-container">
              {data.carrousel.map((image, index) => (
                <img
                  key={index}
                  src={image.imageUrl}
                  alt={`Slide ${index + 1}`}
                  className={`carousel-image ${index === currentIndex ? 'active' : ''}`}
                />
              ))}
            </div>

            <div className="carousel-controls">
              <button className="carousel-control prev" onClick={goToPrevSlide}>
                <ArrowLeft />
              </button>
              <button className="carousel-control next" onClick={goToNextSlide}>
                <ArrowRight />
              </button>
            </div>
          </div>
        )}
      </div>

      <section className="text_section">
        <div className="text_parts">
          <div className="text_content_left" data-aos="fade-right" data-aos-duration="800" data-aos-delay="100">
            {data.colonneGauche?.[language]?.map((paragraph, idx) => (
              <p key={idx} data-aos="fade-in" data-aos-duration="600" data-aos-delay={200 + (idx * 100)}>
                {paragraph.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            ))}
          </div>
          <div className="text_content_right" data-aos="fade-left" data-aos-duration="800" data-aos-delay="100">
            {data.colonneDroite?.[language]?.map((paragraph, idx) => (
              <p key={idx} data-aos="fade-in" data-aos-duration="600" data-aos-delay={200 + (idx * 100)}>
                {paragraph.split('\n').map((line, i) => (
                  <span key={i}>
                    {line}
                    <br />
                  </span>
                ))}
              </p>
            ))}
          </div>
        </div>
      </section>
      
      <section data-aos="fade-in" data-aos-duration="800" data-aos-delay="200">
        <SubPage />
      </section>
    </>
  );
};

export default TransmissionPage;